// In order to load Google Maps API asynchronously we need to specify a callback function to the script loader (see app.js)
CH.initMaps = function() {
    require([
        "jquery",
        "ch_selectors",
        "ch_popup"
    ], function($) {
        function renderMap(containerCanvas) {
            var marker;
            var point = new google.maps.LatLng(CH.map.latitude, CH.map.longitude);
            var mapOptions = {
                zoom: CH.map.zoom,
                center: point,
                mapTypeControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var map = new google.maps.Map(containerCanvas.get(0), mapOptions);

            if (!CH.map.isDefault) {
                marker = new google.maps.Marker({
                    position: point,
                    title: CH.map.title
                });
                marker.setMap(map);
            }
        }
        $(function () {
            if (CH.isNewSemanticStyle) {
                $._('google_map').bind('click', function() {
                    var ModalWindowMapPopupObj = new ModalWindowMapPopup();
                    ModalWindowMapPopupObj.show({
                        onShow: function() {
                            renderMap($('.container' + ' #map-canvas').addClass('loading'))
                        }
                    });
                });
            } else {
                $._('google_map').popUp({
                    type: 'tooltip',
                    title: 'Class Location',
                    content: '<div id="map-canvas" style="width: 496px; height: 486px;"></div>',
                    position:'center',
                    on: 'click',
                    keepAlive: true,
                    cssClass: 'map-tooltip',
                    showCorner: false,
                    maxWidth: 540,
                    modal: true,
                    single: true,
                    tooltipTopOffset: 100,
                    closeByClickOutside: true,
                    afterRender: function(targetElement) {
                        renderMap($('#' + targetElement.attr('popup_id') + ' #map-canvas').addClass('loading'))
                    }
                });
            }
        });
    });
};

define('ch_maps',["optional!google_maps"], function() {});

